import React from "react";
import { CalendarClock, Leaf, HandCoins } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function EngagementQualite() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const badges = [{
    title: "MAITRISE TECHNIQUE ET DES DÉLAIS",
    icon: <CalendarClock className="w-6 h-6" />,
    description: "Planification rigoureuse et suivi"
  }, {
    title: "TRANSITION ENERGÉTIQUE",
    icon: <Leaf className="w-6 h-6" />,
    description: "Bureau d'études certifié RGE"
  }, {
    title: "MAITRISE DES COÛTS",
    icon: <HandCoins className="w-6 h-6" />,
    description: "Transparence et optimisation des coûts"
  }];
  return <section id="engagement-qualité" className="dark bg-background text-foreground py-16 relative overflow-hidden border-y border-border">
      {}
      <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 hidden md:block opacity-20 pointer-events-none">
        <Separator className="bg-border" />
      </div>

      <div ref={ref} className={cn("container mx-auto px-4 relative z-10 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0">
          {badges.map((badge, i) => <div key={i} data-index={i} className={cn("flex flex-col items-center text-center group p-8", i !== badges.length - 1 && "md:border-r md:border-border/10")}>
              <div className="mb-6 p-4 rounded-full bg-primary/10 text-primary ring-1 ring-primary/20 group-hover:bg-primary/30 group-hover:scale-110 transition-all duration-500 ease-out">
                {badge.icon}
              </div>
              
              <h3 className="text-xs font-mono font-medium uppercase tracking-[0.2em] mb-3 text-foreground/90">
                {badge.title}
              </h3>
              
              <p className="text-xs text-muted-foreground max-w-[200px]">
                {badge.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}